import { IconSignature, IconAuth2fa, IconUser, IconTrash, IconCloudUpload, IconFileTypeDoc } from "@tabler/icons-react";

export const data = {
  label: "My Space",
  description: "Everything about you",
  avatar: null,
  sections: [
    {
      label: "Account",
      items: [
        {
          label: "Profile",
          description: "Peek into your personal details and make updates.",
          href: "/private/profile-overview",
          icon: IconUser,
          danger: false,
        },
        {
          label: "Multi-Factor Auth",
          description: "Boost your account's superpower security.",
          href: "/private/one-time-code",
          icon: IconAuth2fa,
          danger: false,
        },
      ],
    },
    {
      label: "Danger zone",
      items: [
        {
          label: "Transfer Data",
          href: "/private/profile-overview#danger-zone",
          icon: IconCloudUpload,
          danger: false,
        },
        {
          label: "Delete Account",
          href: "/private/profile-overview#danger-zone",
          icon: IconTrash,
          danger: true,
        },
      ],
    },
  ],
};
